// extracted by mini-css-extract-plugin
export var menuIcon = "_qz-0";
export var menuIconInline = "_qz-1";